import { getCourseByCatalogId, getCourseById } from 'redux/services/course';
import { CourseAdminMenu } from '../../course_home/components/course-admin-menu';
import AutomatedTranslationMenu from '../../course_home/components/automated-translation-menu';
import HelpWidget from '../components/help-widget';
import LecturePageEditButton from '../../lecture_pages/components/edit-menu/actions/lecture-page-edit-button';

/* @ngInject */
export default function NvHeaderPageLinks(
  $state,
  $stateParams,
  $location,
  CurrentCourseManager,
  CurrentPermissionsManager,
  CurrentUserManager,
  LecturePageManager,
  RailsRoutes,
  TimelinesManager,
  InstitutionsManager,
  _,
  config,
  nvCurrentPage,
) {
  return {
    restrict: 'EA',
    /* eslint-disable complexity */
    link(scope, elem, attrs) {
      scope.$stateParams = $stateParams;
      scope.currentState = $state.current.name;
      scope.nvCurrentPage = nvCurrentPage;
      scope.RailsRoutes = RailsRoutes;
      scope.CurrentUserManager = CurrentUserManager;
      scope.CurrentCourseManager = CurrentCourseManager;
      scope.TimelinesManager = TimelinesManager;
      scope.InstitutionsManager = InstitutionsManager;
      scope.moreActionsDropdownIsOpen = false;
      scope.config = config;

      scope.CourseAdminMenu = CourseAdminMenu;
      scope.AutomatedTranslationMenu = AutomatedTranslationMenu;
      scope.LecturePageEditButton = LecturePageEditButton;
      scope.showAutomatedTranslationMenu = scope.CurrentCourseManager.course.automatedTranslationEnabled && scope.InstitutionsManager.institution.automatedTranslationEnabled;
      scope.hasEditPermissions = CurrentPermissionsManager.isInstructor() || CurrentPermissionsManager.isCourseBuilder() || CurrentPermissionsManager.isConfigAndRegistrationRole();

      scope.HelpWidget = HelpWidget;

      scope.fontColor = nvCurrentPage.getFontColor();

      scope.isExpanded = attrs.isExpanded;

      scope.isProgram = nvCurrentPage.getCourse() ? nvCurrentPage.getCourse().isProgram : false;
      scope.isInProgram = nvCurrentPage.isInProgram();
      scope.filterCoursesInProgram = filterCoursesInProgram;

      scope.coursesInProgram = null;
      scope.coursesInProgramFiltered = null;
      scope.canEditBasics = CurrentPermissionsManager.isConfigAndRegistrationRole();
      scope.isEditOrReorderMode = () => LecturePageManager.isEditMode()
        || LecturePageManager.isReorderMode()
        || TimelinesManager.isEditMode()
        || TimelinesManager.isReorderMode();

      scope.desktopMoreActionsVisible = !nvCurrentPage.isInstitutionPage()
          && (nvCurrentPage.hasTeams()
          || nvCurrentPage.hasGroups()
          || nvCurrentPage.hasLearnersNav()
          || nvCurrentPage.hasTeachingTeamNav()
          || scope.isInProgram);

      scope.mobileMoreActionsVisible = !nvCurrentPage.isInstitutionPage()
          && (nvCurrentPage.hasTeams()
          || nvCurrentPage.hasGroups()
          || nvCurrentPage.hasLearnersNav()
          || nvCurrentPage.hasTeachingTeamNav()
          || nvCurrentPage.hasGallery()
          || nvCurrentPage.hasDiscussions()
          || nvCurrentPage.hasHelpWidget()
          || nvCurrentPage.hasLeaderboard()
          || scope.isInProgram || (scope.MainGridCtrl.hasRhs && nvCurrentPage.hasCommunity()));

      // Quick Access is only hidden to TAs. We're probably missing some cases here, needs refactored
      scope.isQuickAccessVisible = CurrentPermissionsManager.isInstructor() || CurrentPermissionsManager.isCourseBuilder()
            || CurrentPermissionsManager.isReportAdmin() || CurrentPermissionsManager.isConfigAndRegistrationRole();

      scope.$watch('CurrentCourseManager.course.courseLongTeamSet', () => {
        scope.manageTeamsVisible = !!(CurrentCourseManager.course?.courseLongTeamSet)
          && (CurrentPermissionsManager.isConfigAndRegistrationRole() || CurrentPermissionsManager.isInstructor() || CurrentPermissionsManager.isCourseBuilder());
      });
      scope.$watch('CurrentCourseManager.course.groupTeamSet', () => {
        scope.manageGroupsVisible = !!(CurrentCourseManager.course?.groupTeamSet)
          && (CurrentPermissionsManager.isConfigAndRegistrationRole() || CurrentPermissionsManager.isInstructor() || CurrentPermissionsManager.isCourseBuilder());
      });

      scope.$watch('CurrentCourseManager.course.automatedTranslationEnabled', () => {
        scope.showAutomatedTranslationMenu = scope.CurrentCourseManager.course.automatedTranslationEnabled && scope.InstitutionsManager.institution.automatedTranslationEnabled;
      });
      scope.$watch('InstitutionsManager.institution.automatedTranslationEnabled', () => {
        scope.showAutomatedTranslationMenu = scope.CurrentCourseManager.course.automatedTranslationEnabled && scope.InstitutionsManager.institution.automatedTranslationEnabled;
      });

      // initialization if in a program
      if (scope.isInProgram) {
        const parentProgram = getCourseByCatalogId(nvCurrentPage.getParentProgram().catalogId);
        if (parentProgram) {
          scope.coursesInProgram = parentProgram.coursesInProgram;
        }

        if (scope.coursesInProgram?.length) {
          scope.coursesInProgramFiltered = filterCoursesInProgram(scope.coursesInProgram);
        }
      } else if (scope.isProgram) {
        const currentCourse = getCourseById(nvCurrentPage.getCourse().id);
        if (currentCourse) {
          scope.coursesInProgram = currentCourse.coursesInProgram;
        }
      }

      scope.toggleMoreActionsDropdown = function (open) {
        scope.moreActionsDropdownIsOpen = open;
      };

      function filterCoursesInProgram(courses) {
        return _.filter(courses, (courseModel) => courseModel.id !== nvCurrentPage.getCourse().id);
      }
    },
    templateUrl: 'shared/templates/nv-header-page-links.html',
  };
}
